module.exports = __webpack_public_path__ + "img/handraw_panier bleu.0660c04c.svg";